import { css } from '@emotion/css';

export const modalStyles = {
  container: css`
    max-width: 1000px;
    height: 95dvh;
    flex-direction: column;
    @media (max-width: 668px) {
      height: 100dvh;
    }
  `,
  fixedSection: css`
    flex-shrink: 0;
  `,
  imageWrapper: {
    backgroundColor: 'white',
    height: 320,
    backgroundRepeat: 'no-repeat',
  },
  modalContent: css`
    flex: 1;
    min-height: 0;
    max-height: none !important;
  `,
} as const;
